import { useEffect, useRef } from 'react';

/**
 * Direct URL into one pivot's summary on /lenses
 * (?view=pivot_detail_summary&pivot=<id>). LensesScreen restores the view
 * and pivot from the URL, but the summary data only loads in its click
 * handler — this fetches it on arrival too. The dashboard's lens grid
 * deep-links here (specs/workshop-dashboard.md).
 *
 * @param {string|null} pivotId the deep-linked pivot, or null when the page
 *   did not open on the summary view
 * @param {string|undefined} instanceId fires once this resolves
 * @param {(pivotId: string) => void} open the screen's summary loader
 */
export default function useDeepLinkedPivotSummary(pivotId, instanceId, open) {
  const pending = useRef(Boolean(pivotId));
  useEffect(() => {
    if (!pending.current || !instanceId) return;
    pending.current = false;
    open(pivotId);
  }, [instanceId, pivotId, open]);
}
